import React from 'react';
import { useState, useEffect } from 'react';



export const ProfileImage = ({ src,styles }) => {
  const fallbackUrl = 'https://your-dynamic-fallback-url.com/default.jpg';
  const [imgSrc, setImgSrc] = useState(() => getHighResImage(src));

  useEffect(() => {
    setImgSrc(getHighResImage(src));
  }, [src]);
// console.log(imgSrc,"imgSrc");

  return (
    <img
      src={getHighResImage(imgSrc)}
      alt=""
      style={{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        objectFit: 'cover',
        ...styles
      }}
    />
  );
};

function getHighResImage(url) {
    if (!url) return '';
  
    // Match something like "=s32-c" or "=s64-c"
    const match = url.match(/=s(\d+)-c/);
    if (match) {
      const size = parseInt(match[1], 10);
      if (size < 128) {
        // Replace only if size less than 128
        return url.replace(/=s\d+-c/, '=s128-c');
      }
    }
    // Return original url if no match or size >= 128
    return url;
  }
  
